import { DeploymentConfigService } from './deployment-config.service';

export const configInitializerFactory = (deploymentConfig: DeploymentConfigService) => {
  return () => {
    return Promise.all([deploymentConfig.load()]);
  };
};
